/**
 * feature-config flag names owned by agent-access
 *
 * please consider removing this file and adding it to an appropriate place in the
 * feature code (e.g. an entrypoint, or a package owned by the feature team), or
 * passing flag names directly as a string!
 *
 * by separating it out, we decouple the feature code from the feature config packages
 * and avoid the need to update this package when flags are added or removed.
 */

export const AGENT_ACCESS_FLAG_NAMES = {
  // When ON, POST /oauth/authorize rejects site-scoped grants for users who
  // lack SITE_ACTIONS.INSTALL_APP on every selected site (or, for apps in
  // the install-role allowlist, a marketer/editor site role). This codifies
  // the consent UI's `canInstallSiteLevelApp` gate at the server trust
  // boundary — the UI only disables checkboxes, so a crafted POST could
  // otherwise persist a grant the UI would have blocked. Default OFF.
  // Skipped while SITE_LEVEL_APP_INSTALL_BYPASS is ON. EPI-594.
  OAUTH_INSTALL_APP_GRANT_ENFORCEMENT:
    'ff-epi-594-oauth-install-app-grant-enforcement',

  // EXT-757: gates the headless element-snapshot pipeline end to end — the
  // snapshot dispatch to the renderer service, and the getElementSnapshot
  // page-automation toolId. Off by default; kill-switch by turning it off.
  HEADLESS_ELEMENT_SNAPSHOT: 'ff-ext-757-headless-snapshot',

  // CANV-2706: gates the public beta endpoint
  // GET /beta/sites/:site_id/audits/performance. The response shape is a
  // public contract, so the endpoint stays workspace-gated (and unmounted
  // from /v2) until the shape is settled; turning the gate off is the
  // kill switch (workspaces see 404). Default OFF.
  SITE_PERFORMANCE_AUDITS: 'ff-canv-2706-site-performance-audits',
} as const;

export const AGENT_ACCESS_DYNAMIC_CONFIG_NAMES = {
  // Allowlist of app IDs (App container id or OAuth clientId) that marketer
  // and editor site roles may install via the OAuth consent page.
  // Value shape: {appIds: string[]}.
  OAUTH_APP_INSTALL_ROLE_ALLOWLIST: 'dc-epi-oauth-app-install-role-allowlist',
  PUBLIC_LLM_PROXY_ALLOWED_CLIENT_IDS:
    'dc-pion-768-public-llm-proxy-allowed-client-ids',
  // CANV-2706: per-token in-flight cap for the public performance-audit
  // endpoint. Value shape: {perToken: number}.
  AUDITS_PUBLIC_CONCURRENCY_LIMIT:
    'dc-canv-2706-audits-public-concurrency-limit',
  // CANV-2765: kill switch for the Google Tag Manager findings in the
  // performance-audit endpoint. Value shape: {enabled: boolean}. Enabled when
  // the config doesn't exist.
  AUDITS_GTM_FINDINGS: 'dc-canv-2765-audits-gtm-findings',
} as const;
